<template>
  <div class="wrapper article-level-nine" :class="{'article-level-nine--opinion': articleType === 'opinion'}"
    :gtm-event-label="`${node.relative_url}`"
    >
    <div class="card">
      <div class="media">
        <div class="media-body">
          <node-label class="card-section" :nid="nid" :noColor="true">
            <SpeechBalloonLabel v-if="articleType === 'opinion'" v-slot:speechBalloonLabel :nid="nid" size="small-20-responsive" mainComponent="article-level-nine__node-label"></SpeechBalloonLabel>
            <SpeechBalloonLabel v-else-if="articleType === 'live'" v-slot:speechBalloonLabel :nid="nid" size="small-20-responsive" mainComponent="article-level-nine__node-label" showAnimation></SpeechBalloonLabel>
          </node-label>
          <div class="card-title">
            <node-link
              v-gtm-tracker="!isEmpty(gtmType) ? assignIn({}, gtmType, {el: get(node, 'relative_url', false)}) : {}"
              :url="node.relative_url"
              :type="node.type"
              :nid="node.nid"
              :title="node.title"
              :destinationTid="destinationTid"
            >{{title}}</node-link>
          </div>
        </div>
        <div class="d-flex align-self-top card-image">
          <icon-indicator :nid="nid" class="indicator"></icon-indicator>
          <node-link
            v-gtm-tracker="!isEmpty(gtmType) ? assignIn({}, gtmType, {el: get(node, 'relative_url', false)}) : {}"
            class="image-wrapper"
            :url="node.relative_url"
            :type="node.type"
            :nid="node.nid"
            :title="node.title"
            :destinationTid="destinationTid">
            <progressive-image v-if="image" :progressiveImage="progressiveImage" :alt="node.title" width="106"
            height="106" :lazyload="lazyload" />
          </node-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NodeLabel from 'components/node/Label.vue'

import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import assignIn from 'lodash/assignIn'

import lazyloadImage from 'components/mixins/lazyloadImage'
import { getArticleType, getSocialHeadLineAsTitle } from 'mixins/utilities'

export default {
  name: 'article-level-nine',
  mixins: [lazyloadImage],
  props: {
    destinationTid: [Number, String, Boolean],
    gtmType: {
      type: Object,
      default: () => ({}),
    },
    lazyload: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    NodeLabel,
    IconIndicator: () => import('components/article-levels/IconIndicator'),
    SpeechBalloonLabel: () => import('components/common/SpeechBalloonLabel'),
  },
  computed: {
    title() {
      return getSocialHeadLineAsTitle(this.node)
    },
    image() {
      return get(this, 'node.images[0].style_140x140')
    },
    articleType() {
      return getArticleType(this.node)
    },
    progressiveImage() {
      return {
        src: this.image,
        loading: !this.lazyload ? this.image : false,
        svg: {
          width: 1,
          height: 1,
        },
      }
    },
  },
  data() {
    return {}
  },
  methods: {
    isEmpty,
    get,
    assignIn,
  },
}
</script>
<style lang="scss">
.article-level-nine {
  font-family: $barlow;

  img {
    width: rem-calc(106);
    height: rem-calc(106);
  }

  a {
    color: $white;
  }

  a:active,
  a:focus {
    img {
      -webkit-filter: $image-hover-opacity;
      filter: $image-hover-opacity;
    }
  }

  .image-wrapper {
    width: rem-calc(80);
    height: rem-calc(80);
    margin-top: rem-calc(25);
  }

  .card {
    border: none;
    background-color: transparent;
  }

  .card-image {
    position: relative;
    margin-left: rem-calc(8);
    max-width: rem-calc(106);
    @include respond-to("desktop") {
      margin-left: rem-calc(16);
    }
  }

  .card-block {
    padding: 0;
  }

  .card-section {
    color: $white;
    font-weight: bold;

    text-transform: uppercase;
    vertical-align: top;
    margin-top: rem-calc(3);
    margin-bottom: rem-calc(4);

    font-size: rem-calc(14);
    line-height: rem-calc(14);
    @include respond-to("desktop") {
      font-size: rem-calc(20);
      line-height: rem-calc(24);
    }
    a {
      color: $white;
    }
  }

  .card-title {
    margin-bottom: 0;
    color: $white;
    font-size: rem-calc(21);
    line-height: rem-calc(24);

    @include respond-to("desktop") {
      font-size: rem-calc(28);
      line-height: rem-calc(34);
    }
  }

  .fields {
    vertical-align: top;
  }

  &--opinion {
    .card-section {
      margin-bottom: 0;
    }

    // Child component classes
    .fields {
      display: inline-block;
    }

    .fields {
      margin-bottom: rem-calc(4);
    }
  }
}
</style>
<style lang="scss" scoped>
  /deep/ .icon-wrapper {
    vertical-align: unset;
    color: $fluorescent-pink;
    svg {
      fill: currentColor;
      vertical-align: text-top;
    }
  }
  .indicator {
    left: rem-calc(4);
    bottom: rem-calc(4);
    width: rem-calc(24);
    height: rem-calc(24);
  }
</style>



// WEBPACK FOOTER //
// components/article-levels/Lv9.vue